import React, { Component } from 'react';
import { TabBar } from 'antd-mobile';
import Constants from '../utils/Constants';
import StorageUtils from '../utils/StorageUtils';
import iconOrder from '../medias/icon-order.svg';
import iconOrderSelected from '../medias/icon-order-selected.svg';
import iconHome from '../medias/icon-home.svg';
import iconHomeSelected from '../medias/icon-home-selected.svg';
import DataFetcher from '../utils/DataFetcher';
import KfHome from './KfHome';
import KfLog from './KfLog';

const history = require("history").createHashHistory()

class Kf extends Component {
    constructor(props){
        super(props);

        let selectedTab = StorageUtils.retrieveStringFromSession(Constants.Storage.HOME_SELECTED_TAB);
        if (!selectedTab||selectedTab==='') {
            selectedTab = 'homeTab';
        }

        this.state = {
            selectedTab: selectedTab
        }
        
    }

    componentDidMount() {
        this.loadKfProfile()
    }

    loadKfProfile = () => {
        DataFetcher.kfProfile({
            success: (resp) => {
            },
            logicError: () => {
                history.replace("/about")
            },
            sysError: () => {
                history.replace("/about")
            }
        })
    }

    render() {
        const { selectedTab } = this.state;
        StorageUtils.storeStringToSession(Constants.Storage.HOME_SELECTED_TAB, selectedTab);

        return (
            <div className="app-container">
                <TabBar unselectedTintColor="#8a8a8a" tintColor="#04bbc5" barTintColor="white">
                    <TabBar.Item 
                        title="客服" 
                        key="Home" 
                        icon={iconHome}
                        selectedIcon={iconHomeSelected}
                        selected={selectedTab === 'homeTab'}
                        onPress={() => {
                            this.setState({
                                selectedTab: 'homeTab'
                            });
                        }}
                    >
                        <KfHome tabName="homeTab"/>
                    </TabBar.Item>
                    <TabBar.Item
                        title="记录"
                        key="Log"
                        icon={iconOrder}
                        selectedIcon={iconOrderSelected}
                        selected={selectedTab === 'logTab'}
                        onPress={() => {
                            this.setState({
                                selectedTab: 'logTab'
                            });
                        }}
                    >  
                        <KfLog tabName="logTab"/>
                    </TabBar.Item>
                </TabBar>
            </div>
        )
    }
}

export default Kf;


// WEBPACK FOOTER //
// ./src/modules/Kf.js